import gql from "graphql-tag";

export default gql`
  mutation CreateSubdeployment($subdeploymentInput: SubdeploymentInputInput, $deploymentId: ID) {
    createSubdeployment(subdeploymentInput: $subdeploymentInput, deploymentId: $deploymentId) {
      id
    }
  }
`;